import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import CommonPage from "../Components/CommonPage/CommonPage";
import Footer from "../Components/Footer/Footer";
import Header from "../Components/Header/Header";
import HeaderAccountsPage from "../Components/Header/HeaderAccountsPage";
import About from "../Screens/About/About";
import Faq from "../Screens/Faq/Faq";
import AccountSettings from "../Screens/Accounts/AccountSettings/AccountSetting";
import BillingDetails from "../Screens/Accounts/AccountSettings/BillingDetails";
import GiftDetails from "../Screens/Accounts/AccountSettings/GiftDetails";
import B2BDetailScreen from "../Screens/B2BDetailsScreen/B2BDetailsScreen";
import StreamingActivity from "../Screens/Accounts/AccountSettings/StreamingActivity";
import ChangePassword from "../Screens/Accounts/ChangePassword/ChangePassword";
import SetPassword from "../Screens/Accounts/SetPassword/SetPassword";
import ForgotPassword from "../Screens/Accounts/ForgotPassword/ForgotPassword";
import ResetPassword from "../Screens/Accounts/ForgotPassword/ResetPassword";
import ParentalSettings from "../Screens/Accounts/ParentalPinReset/ParentalSettings";
import VerifyParentalPinReset from "../Screens/Accounts/ParentalPinReset/VerifyParentalPinReset";
import ConfirmParentalPinReset from "../Screens/Accounts/ParentalPinReset/ConfirmParentalPinReset";
import Login from "../Screens/Accounts/Login/Login";
import Register from "../Screens/Accounts/Register/Register";
import ContactSupport from "../Screens/ContactPages/ContactSupport";
import ContactUs from "../Screens/ContactPages/ContactUs";
import Homepage from "../Screens/homepage/Homepage";
import KidsLanding from "../Screens/KidsLanding/KidsLanding";
import LandingScreeen from "../Screens/LandingScreen/LandingScreeen";
import MyList from "../Screens/MyList/MyList";
import LatestNews from "../Screens/NewsSection/LatestNews";
import NewsDetails from "../Screens/NewsSection/NewsDetails";
import NotFound from "../Screens/NotFound/NotFound";
import GeoBlock from "../Screens/NotFound/GeoBlock";
import PaymentFailed from "../Screens/PaymentStatus/PaymentFailed/PaymetFailed";
import PaymentSuccess from "../Screens/PaymentStatus/PaymentSuccess/PaymentSuccess";
import PrivacyPolicy from "../Screens/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "../Screens/Disclaimer/Disclaimer";
import Search from "../Screens/Search/Search";
import DetailsScreen from "../Screens/ShowDetailsScreen/DetailsScreen";
import Payment from "../Screens/Subscription/Payment";
import Subscription from "../Screens/Subscription/Subscription";
import TermsAndConditions from "../Screens/TermsAndConditions/TermsAndConditions";
import PrivateRoutes from "./PrivateRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
import LinkTvApp from "../Screens/LinkTvApp/LinkTvApp";
import LivePlayer from "../Screens/LivePlayer/LivePlayer";
import PodcastModal from "../Components/Modals/PodcastModal";
import WebViewFailed from "../Screens/PaymentStatus/PaymentFailed/WebViewFailed";
import WebViewSuccess from "../Screens/PaymentStatus/PaymentSuccess/WebViewSuccess";
import AffliatePage from "../Screens/AffliatePage/AffliatePage";
import OpenApp from "../Components/OpenApp/OpenApp";
import { checkOperatingSystem } from "../utils/utils";
import LiveChannels from "../Screens/LiveChannels/LiveChannels";
import LiveChannelsNew from "../Screens/LiveChannels/LiveChannelsNew";
import LiveChannelsLegacy from "../Screens/LiveChannels/LiveChannelsLegacy";
import AffliateTestPage from "../AffliateTestPage";
import LanguageModal from "../Components/Modals/LanguageModal";
import VerifyApp from "../Screens/VerifyApp/VerifyApp";
import { affliateAnalytics } from "../network/service";
import EventDetailsScreen from "../Screens/EventDetails/EventDetailsScreen";
import TopBanner from "../Components/TopBanner/TopBanner";
import CustomHeader from "../Components/Header/CustomHeader";
import TVAppIndex from "../Screens/LinkTvApp/TVAppIndex";
import LoginRequest from "../Screens/LoginRequest/LoginRequest";
import VideoPlayer from "../Screens/VideoPlayer/VideoPlayer";
import ShowAllEpisodes from "../Screens/ShowAllEpisodes/ShowAllEpisodes";
import ContentProducersBlank from "../Components/Header/ContentProducersBlank";
import Shorts from "../Screens/Shorts/Shorts";
import Checkout from "../Screens/Accounts/Checkout/Checkout";
import ProgressBar from "../Components/Modals/LoginModal/ProgressBarModal";
import Trailer from "../Screens/Trailer/Trailer";
import GaiaHeader from "../Components/Header/GaiaHeader";
import GaiaDetailsScreen from "../Screens/ShowDetailsScreen/GaiaDetailsScreen"
import YowDetailsScreen from "../Screens/ShowDetailsScreen/YowDetailsScreen";
import { getUpdatePaymentLink } from '../network/service';
import Translate from "../Components/Multilanguage/Translate";
import GaiaEventDetailsScreen from "../Screens/EventDetails/GaiaEventDetailsScreen";
import Resubscribe from "../Screens/Accounts/Resubscribe/Resubscribe";
import Calendar from "../Screens/Calendar/Calendar";
import NewBlockHeader from "../Components/Header/NewBlockHeader";
import GiftAdd from "../Screens/Gift/GiftAdd";
import GiftClaim from "../Screens/Gift/GiftClaim";
import GiftSuccess from "../Screens/Gift/GiftSuccess";
import GiftFail from "../Screens/Gift/GiftFail";
import AboutNewVibe from "../Screens/About/AboutNewVibe";
import ChannelsPage from "../Components/Channels/ChannelsPage";
import SquarePaymentProcessing from "../Screens/Subscription/SquarePaymentProcessing";
import NewBlockComingSoon from "../Screens/NewBlock_ComingSoon/NewBlock_ComingSoon";
import VerticalShowPlayer from "../Screens/VerticalShowPlayer/VerticalShowPlayer";
import Checkout2 from "../Screens/Accounts/Checkout2/Checkout2";
import Checkout3 from "../Screens/Accounts/Checkout3/Checkout3";
import godtvBg from "../assets/Images/godtv_bg.png";
import godtvBg2 from "../assets/Images/godtv_bg2.png";
import ParentalPasscodeModal from "../Components/Modals/ParentalPasscodeModal";
import BundleList from "../Screens/Bundles/BundleList";
import NewAccountSettings from "../Screens/Accounts/AccountSettings/NewAccountSetting";
import AccountSettings2 from "../Screens/Accounts/AccountSettings/AccountSetting2";
import OurSports from "../Screens/OurSports/OurSports";
import FlsLandingPage from "../Screens/FlsLandingPage/FlsLandingPage";
import FlsScrollToLandingButton from "../Components/FlsScrollToLandingButton/FlsScrollToLandingButton";
import SportsPage from "../Screens/Sports/SportsPage";
import OurChannels from "../Screens/OurChannels/OurChannels";
import FlsChannelDetail from "../Screens/OurChannels/FlsChannelDetail";
import FlsPageFooter from "../Components/FlsPageFooter/FlsPageFooter";

const LayoutsRoutes = () => {
  const location = useLocation();
  const [initialPage, setInitialPage] = useState("");
  const [hideHeaderFooter, setHideHeaderFooter] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isDocPlus = [50158, 50157, 50196].includes(projectInfo?.projectConfig?.pubid);
  const isNewLiveChannels = projectInfo?.projectConfig?.config?.WEBSITE_NEW_EPG_LAYOUT === true || projectInfo?.projectConfig?.config?.WEBSITE_NEW_EPG_LAYOUT === "true";
  const podcastModal = useSelector((state) => state?.podcastModal?.value);
  const languageModal = useSelector(
    (state) => state?.languageModal?.value?.isOpen
  );
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const urlParams = new URLSearchParams(window.location.search);
  const affliateId = localStorage?.getItem("affliateId");
  const navigate = useNavigate();
  const [isOpenAppFeature, setIsOpenAppFeature] = useState(false);
  const [isOpenAppFeatureClosed, setIsOpenFeatureClosed] = useState(false);
  const downloadB2bModal = useSelector((state) => state?.downloadB2bModal?.value);
  const androidToken = urlParams.get("antkn");
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  const [isCheckoutPath, setIsCheckoutPath] = useState(false);
  const showFlsChannelFooter = location.pathname.startsWith("/channel/")
    && location.pathname !== "/channel/channels";

  useEffect(() => {
    setIsCheckoutPath(/^\/checkout(\/.*)?$/.test(location?.pathname));
  }, [location?.pathname]);

  useEffect(() => {
    if (urlParams.has('d') && urlParams.get('d') === 'm') {
      setHideHeaderFooter(true);
    } else {
      setHideHeaderFooter(false);
    }
  }, [urlParams]);

  useEffect(() => {
    if (!androidToken) {
      let openAppFeatureNotNeededRoutes = ["/privacy-policy", "/terms-and-conditions", "/subscription", "/paidplans", "/payment", "/success", "/failed", "/404", "/checkout"];
      // Use the state variable instead of re-calculating
      if (
        (checkOperatingSystem() === "android" ||
          checkOperatingSystem() === "iPhone") &&
        !openAppFeatureNotNeededRoutes?.includes(location?.pathname)
        && !isCheckoutPath
        &&
        projectInfo?.projectConfig?.config?.DEEP_LINKING_ENABLED === "true"
        &&
        isOpenAppFeatureClosed === false
      ) {
        setIsOpenAppFeature(true);
      } else {
        setIsOpenAppFeature(false)
      }
    }
  }, [androidToken, location, isCheckoutPath]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (affliateId) {
      console.log("Affiliate ID detected", affliateId);

      if (checkOperatingSystem() === "android" || checkOperatingSystem() === "iPhone") {
        // navigate("/");
        // window.location.href = "/home";
        setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);
        updateAffliateAnalytics()

      } else {
        setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);
        updateAffliateAnalytics()
      }
    } else {
      setInitialPage(projectInfo?.projectConfig?.config?.INITIAL_PAGE);

    }
  }, []);

  const updateAffliateAnalytics = async () => {
    try {
      const response = await affliateAnalytics(appInfo);
      if (response.status === 200) {
        localStorage.removeItem("affliateId");
        localStorage.removeItem("affliateUrl");
        const remainingParams = new URLSearchParams(location.search);
        remainingParams.delete("af_id");
        remainingParams.delete("ref");
        const search = remainingParams.toString();

        navigate(
          {
            pathname: location.pathname,
            search: search ? `?${search}` : "",
            hash: location.hash,
          },
          { replace: true }
        );

      }
    } catch (err) {
      localStorage.removeItem("affliateId");
      localStorage.removeItem("affliateUrl");
    }
  }

  const updatePaymentDetails = async () => {
    const response = await getUpdatePaymentLink(appInfo);
    if (response.status === 200) {
      console.log(response.data);
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    }
  }

  const resubscribe = () => {
    navigate('/resubscribe', { state: { userSubscriptionId: userDetails?.user_subscription_id } });
  }

  if (affliateId && (checkOperatingSystem() === "android" || checkOperatingSystem() === "iPhone")) {
    return (
      <Routes>
        <Route path="/">
          <Route path="/" element={<Navigate to="/redirect" />} />
        </Route>
        <Route path="/redirect" element={<AffliatePage />} />
      </Routes>
    );
  } else {

    function RedirectToRegisterWithIOSProps() {
      const navigate = useNavigate();

      useEffect(() => {
        localStorage.setItem('iosSignup', true);
        // Redirect to /register with props iosSignup={true} after component is mounted
        navigate('/register', { state: { iosSignup: true } });
      }, [navigate]);

      // Navigate component must return null
      return null;
    }



    return (
      initialPage && (
        <div id="main" className="LayoutsContainer">
          {projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && location?.pathname !== "/login" &&
            location?.pathname !== "/register" &&
            location?.pathname !== "/ios-signup" &&
            location?.pathname !== "/forgot-password" &&
            location?.pathname !== "/forgot-password/reset" &&
            !location?.pathname?.includes("/reset-parental-pin") &&
            projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED !== "true"
            ? initialPage !== "AFFLIATEPAGE" && localStorage.getItem('iosSignup') !== 'true' && (
              <>
                {
                  // !hideHeaderFooter && !androidToken && <Header />
                  !hideHeaderFooter && !androidToken && (
                    template === "TEMPLATE_10" ? <GaiaHeader isCheckoutPath={isCheckoutPath} /> : template === "TEMPLATE_11" ? <NewBlockHeader /> : <Header />
                    // <Header />
                  )
                }

                {/* <TopBanner/> */}
              </>
            ) : projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" &&
              projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED === "true"
              ? initialPage !== "AFFLIATEPAGE" && (
                <CustomHeader />
              )
              : initialPage !== "AFFLIATEPAGE" && projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && projectInfo?.projectConfig?.config?.CUSTOM_HEADER_REQUIRED !== "true" && (
                template === "TEMPLATE_12"
                  ? <Header />
                  : <HeaderAccountsPage />
              )}
          {podcastModal?.isOpen && <PodcastModal data={podcastModal?.data} />}

          {languageModal?.isOpen && <LanguageModal />}

          {template === 'TEMPLATE_12' && <ParentalPasscodeModal />}

          {isOpenAppFeature && (
            <OpenApp setIsOpenAppFeature={setIsOpenAppFeature} setIsOpenFeatureClosed={setIsOpenFeatureClosed} />
          )}

          {userDetails?.default_payment_method_exists === false && !isCheckoutPath &&
            < div className="resubscriptionInfo">
              <div className="resubscribeMessage">
                <Translate textKey={'update_payment_method_message'} />
              </div>
              <div className="resubscribeButton" onClick={() => { updatePaymentDetails() }} style={{ backgroundColor: projectInfo?.projectConfig?.config?.BACKGROUND_COLOR, color: projectInfo?.projectConfig?.config?.TEXT_COLOR, border: `1px solid ${projectInfo?.projectConfig?.config?.TEXT_COLOR}` }}>
                <Translate textKey={'update'} />
              </div>
            </div>
          }

          {userDetails?.user_subscription_id && location?.pathname !== "/resubscribe" && !isCheckoutPath &&
            < div className="resubscriptionInfo">
              <div className="resubscribeMessage">
                <Translate textKey={'membership_expired'} />
              </div>
              <div className="resubscribeButton" onClick={() => { resubscribe() }} style={{ backgroundColor: projectInfo?.projectConfig?.config?.BACKGROUND_COLOR, color: projectInfo?.projectConfig?.config?.TEXT_COLOR, border: `1px solid ${projectInfo?.projectConfig?.config?.TEXT_COLOR}` }}>
                <Translate textKey={'resubscribe'} />
              </div>
            </div>}

          <div
            className="routesContainer"
            style={projectInfo?.projectConfig?.pubid === 50174 ? {
              backgroundImage: `url(${isMobile ? godtvBg : godtvBg2})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center top',
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'fixed',
            } : undefined}
          >
            {
              projectInfo?.projectConfig?.config?.GEO_BLOCKED === true &&
                !projectInfo?.projectConfig?.config?.GEO_UNBLOCKED_COUNTRIES.includes(projectInfo?.geoInfo.countryCode) ? (
                <GeoBlock />
              ) :
                (<Routes>
                  {/* for which page need to show initial */}
                  <Route path="/">
                    {initialPage === "LANDING" ? (
                      <Route path="/" element={<LandingScreeen />} />
                    ) : initialPage === "LOGIN" ? (
                      <Route path="/" element={<Navigate to="/login" />} />
                    ) : initialPage === "HOME" ? (
                      <Route
                        path="/"
                        element={
                          <Navigate to={`/home${location.search}`} replace />
                        }
                      />
                    ) : initialPage === "LIVE" ? (
                      <Route path="/" element={<Navigate to="/live-channels" />} />
                    ) : null}
                  </Route>

                  <Route element={<PublicRoutes />}>

                    <Route path="/checkout/:subscribe/:purchase" element={<Navigate to="/register" />} />
                    <Route path="/login"
                      element={template === "TEMPLATE_12" ? <KidsLanding isLogin /> : (
                        projectInfo?.projectConfig?.pubid === 50124
                          ? <Login />
                          : projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" && !location?.state?.useLegacyLogin
                            ? <Navigate to="/checkout" replace />
                            : <Login />
                      )}
                    />
                    <Route path="/register" element={
                      template === "TEMPLATE_12" ? <KidsLanding isLogin={false} /> : (
                        projectInfo?.projectConfig?.config?.TIERED_PRICING_UI === "true"
                          ? <Checkout2 /> : <Register />
                      )}
                    />
                    {/* <Route path="/ios-signup" element={<Register iosSignup={true} />} /> */}
                    <Route path="/ios-signup" element={<RedirectToRegisterWithIOSProps />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                  </Route>

                  <Route path="/loginRequest" element={<LoginRequest />} />
                  <Route path="/reset-parental-pin/:token" element={<VerifyParentalPinReset />} />
                  <Route path="/reset-parental-pin/confirm" element={<ConfirmParentalPinReset />} />

                  <Route element={<PrivateRoutes />}>
                    <Route path="/sample" element={<AffliateTestPage />} />
                    <Route path="/verify-app" element={<VerifyApp />} />
                    <Route path="/videos/:vanityUrl" element={<VideoPlayer />} />
                    <Route path="/B2B/:name" element={<B2BDetailScreen />} />
                    <Route
                      path="/episode/:vanityUrl"
                      element={<Navigate to={`/videos/${location.pathname.split('/').pop()}`} state={location?.state} />}
                    />
                    <Route path="/trailer/:vanity" element={<Trailer />} />
                    <Route path="/video/:vanityUrl" element={template === "TEMPLATE_10" ? <GaiaDetailsScreen /> : <DetailsScreen />} />

                    <Route path="/home" element={localStorage.getItem('iosSignup') == 'true' ? <Navigate to="/subscription" /> : <>
                      <Homepage />
                      {Number(projectInfo?.projectConfig?.pubid) === 50183 && <FlsScrollToLandingButton />}
                      {Number(projectInfo?.projectConfig?.pubid) === 50183 && <FlsLandingPage isHome={true} />}
                    </>} />

                    <Route path="/show-details/:name" element={template === "TEMPLATE_10" ? <GaiaDetailsScreen /> : <DetailsScreen />} />
                    <Route
                      path="/show/:name"
                      element={<Navigate to={`/show-details/${location.pathname.split('/').pop()}`} state={location?.state} />}
                    />
                    <Route path="/vertical-show/:showIdentifier" element={<VerticalShowPlayer />} />
                    <Route path="/vertical-show/:showIdentifier/:episodeIdentifier" element={<VerticalShowPlayer />} />
                    <Route path="/bundles/purchase" element={<BundleList />} />

                    <Route path="/event/:eventId" element={template === "TEMPLATE_10" ? <GaiaEventDetailsScreen /> : <EventDetailsScreen />} />
                    <Route path="/category/:careers" element={<CommonPage />} />
                    <Route path="/channels" element={<ChannelsPage />} />
                    <Route path="/genre/:key" element={<Homepage />} />
                    <Route path="/partner/:partnerId" element={<CommonPage />} />
                    <Route path="/calendar" element={<Calendar />} />
                    {Number(projectInfo?.projectConfig?.pubid) === 50183 && (
                      <>
                        <Route path="/our-sports" element={<OurSports />} />
                        <Route path="/oursports" element={<OurSports />} />
                        <Route path="/sport/sports" element={<OurSports />} />
                        <Route path="/fls-landing" element={<FlsLandingPage />} />
                        <Route path="/ways-to-watch" element={<FlsLandingPage />} />
                        <Route path="/free-live-sports-tv" element={<FlsLandingPage />} />
                        <Route path="/landing-page" element={<FlsLandingPage />} />
                        <Route path="/our-channels" element={<OurChannels />} />
                        <Route path="/channel/channels" element={<OurChannels />} />
                        <Route path="/channel/:vanityUrl" element={<FlsChannelDetail />} />
                        <Route path="/action-extreme-sports" element={<SportsPage pageKey="action-extreme-sports" />} />
                        <Route path="/sport/action-extreme-sports" element={<SportsPage pageKey="action-extreme-sports" />} />
                        <Route path="/basketball" element={<SportsPage pageKey="basketball" />} />
                        <Route path="/sport/basketball" element={<SportsPage pageKey="basketball" />} />
                        <Route path="/billiards" element={<SportsPage pageKey="billiards" />} />
                        <Route path="/sport/billiards" element={<SportsPage pageKey="billiards" />} />
                        <Route path="/extreme-sports" element={<SportsPage pageKey="extreme-sports" />} />
                        <Route path="/sport/extreme-sports" element={<SportsPage pageKey="extreme-sports" />} />
                        <Route path="/football" element={<SportsPage pageKey="football" />} />
                        <Route path="/sport/football" element={<SportsPage pageKey="football" />} />
                        <Route path="/horseback-riding" element={<SportsPage pageKey="horseback-riding" />} />
                        <Route path="/sport/horseback-riding" element={<SportsPage pageKey="horseback-riding" />} />
                        <Route path="/baseball" element={<SportsPage pageKey="baseball" />} />
                        <Route path="/sport/baseball" element={<SportsPage pageKey="baseball" />} />
                        <Route path="/lacrosse" element={<SportsPage pageKey="lacrosse" />} />
                        <Route path="/sport/lacrosse" element={<SportsPage pageKey="lacrosse" />} />
                        <Route path="/mixed-martial-arts" element={<SportsPage pageKey="mixed-martial-arts" />} />
                        <Route path="/sport/mixed-martial-arts" element={<SportsPage pageKey="mixed-martial-arts" />} />
                        <Route path="/motorsport" element={<SportsPage pageKey="motorsport" />} />
                        <Route path="/sport/motorsport" element={<SportsPage pageKey="motorsport" />} />
                        <Route path="/poker" element={<SportsPage pageKey="poker" />} />
                        <Route path="/sport/poker" element={<SportsPage pageKey="poker" />} />
                        <Route path="/other-sports" element={<SportsPage pageKey="other-sports" />} />
                        <Route path="/sport/other-sports" element={<SportsPage pageKey="other-sports" />} />
                      </>
                    )}
                    <Route path="/search" element={<Search />} />
                    {projectInfo?.projectConfig?.pubid === 50147 && (
                      <Route path="/comingsoon" element={<NewBlockComingSoon />} />
                    )}
                    {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" && (
                      <>
                        <Route path="/gift/purchase" element={<GiftAdd />} />
                        <Route path="/gift/claim" element={<GiftClaim />} />
                        <Route path="/gift/success" element={<GiftSuccess />} />
                        <Route path="/gift/failed" element={<GiftFail />} />
                      </>
                    )}
                    <Route path="/episodes/:showname" element={<ShowAllEpisodes />} />
                    <Route
                      path="/forgot-password/reset/:token"
                      element={<ResetPassword />}
                    />
                    <Route path="/language-selection" element={<LanguageModal type="root" />} />
                    <Route
                      path="/terms-and-conditions"
                      element={<TermsAndConditions />}
                    />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/disclaimer" element={<Disclaimer />} />
                    <Route path="/contact-us" element={<ContactUs />} />
                    <Route path="/resubscribe" element={<Resubscribe />} />
                    <Route path="/contact-support" element={<ContactSupport />} />
                    <Route path="/about-us" element={
                      projectInfo?.projectConfig?.pubid === 50146 ? (<AboutNewVibe />) : (<About />)}
                    />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/news" element={<LatestNews />} />
                    <Route path="/news-info/:newsId" element={<NewsDetails />} />
                    <Route path="/subscription" element={projectInfo?.projectConfig?.pubid === 50167 ? <Navigate to="/paidplans" replace /> : <Subscription />} />
                    <Route path="/paidplans" element={projectInfo?.projectConfig?.pubid === 50167 ? <Subscription /> : <Navigate to="/subscription" replace />} />
                    <Route path="/checkout" element={isDocPlus ? <Checkout3 /> : <Checkout />} />
                    <Route path="/checkout/:key" element={isDocPlus ? <Checkout3 /> : <Checkout />} />
                    <Route path="/redirect" element={<Navigate to="/home" />} />
                    <Route path="/browse" element={<Navigate to="/home" />} />
                    <Route path="/affliate" element={<AffliatePage />} />
                    <Route path="/live-channels" element={isNewLiveChannels ? <LiveChannelsNew /> : <LiveChannelsLegacy />} />
                    <Route path="/livestream" element={isNewLiveChannels ? <LiveChannelsNew /> : <LiveChannelsLegacy />} />
                    <Route path="/live" element={<LivePlayer />} />
                    <Route path="/player" element={<Navigate to="/live" state={location?.state} />} />
                    <Route path="/blank" element={<ContentProducersBlank />} />
                  </Route>

                  <Route element={<ProtectedRoutes />}>
                    <Route path="/shorts" element={<Shorts />} />
                    <Route path="/shorts/:vanityUrl" element={<Shorts />} />
                    <Route path="/failed" element={<PaymentFailed />} />
                    <Route path="/webviewfailed" element={<WebViewFailed />} />
                    <Route path="/success" element={<PaymentSuccess />} />
                    <Route path="/webviewsuccess" element={<WebViewSuccess />} />
                    <Route path="/change-password" element={<ChangePassword />} />
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route
                      path="/account"
                      element={
                        [50158, 50157].includes(projectInfo?.projectConfig?.pubid)
                          ? <AccountSettings2 />
                          : projectInfo?.projectConfig?.config?.TOKEN_SUBSCRIPTION_REQUIRED === "true"
                            ? <NewAccountSettings />
                            : <AccountSettings />
                      }
                    />
                    <Route path="/parental-settings" element={<ParentalSettings />} />
                    <Route
                      path="account/billing-activity"
                      element={<BillingDetails />}
                    />
                    {projectInfo?.projectConfig?.config?.GIFT_REQUIRED === "true" &&
                      <Route
                        path="account/gift-activity"
                        element={<GiftDetails />}
                      />
                    }
                    <Route
                      path="account/streaming-activity"
                      element={<StreamingActivity />}
                    />
                    <Route path="/resubscribe" element={<Resubscribe />} />
                    <Route path="/payment" element={<Payment />} />
                    <Route path="/my-list" element={<MyList />} />
                    <Route path="/tv" element={<TVAppIndex />} />
                    <Route path="/squareReturn" element={<SquarePaymentProcessing />} />
                  </Route>

                  <Route path="*" element={<Navigate to="/404" />}></Route>
                  <Route path="/404" element={<NotFound />} />


                </Routes>)
            }
          </div>

          {showFlsChannelFooter && <FlsPageFooter showHowToWatch showDirectory />}

          {
            downloadB2bModal?.downloadProgress && <ProgressBar downloadB2bModal={downloadB2bModal} />
          }

          {initialPage !== "AFFLIATEPAGE" && projectInfo?.projectConfig?.config?.WEBSITE_NOT_NEEDED !== "true" && localStorage.getItem('iosSignup') !== 'true' &&
            !hideHeaderFooter && !androidToken && <Footer style={{ flexShrink: 0 }} />}
        </div>
      )
    );
  }
};

export default LayoutsRoutes;
